/* js/pages/HaltePage.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	check_outros,
	create_component,
	destroy_component,
	detach,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	transition_in,
	transition_out
} from "svelte/internal";

import HaltePodcastAndVideo from "../components/HaltePodcastAndVideo.svelte";
import HalteMultitrack from "../components/HalteMultitrack.svelte";
import { StepType } from "../StepType";
import { db } from '../Db';

function create_else_block(ctx) {
	let haltemultitrack;
	let current;

	haltemultitrack = new HalteMultitrack({
			props: {
				halteType: /*halteType*/ ctx[1],
				halte: /*halte*/ ctx[0],
				nextHalte: /*nextHalte*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(haltemultitrack.$$.fragment);
		},
		m(target, anchor) {
			mount_component(haltemultitrack, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const haltemultitrack_changes = {};
			if (dirty & /*halteType*/ 2) haltemultitrack_changes.halteType = /*halteType*/ ctx[1];
			if (dirty & /*halte*/ 1) haltemultitrack_changes.halte = /*halte*/ ctx[0];
			if (dirty & /*nextHalte*/ 4) haltemultitrack_changes.nextHalte = /*nextHalte*/ ctx[2];
			haltemultitrack.$set(haltemultitrack_changes);
		},
		i(local) {
			if (current) return;
			transition_in(haltemultitrack.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(haltemultitrack.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(haltemultitrack, detaching);
		}
	};
}

// (17:0) {#if halte.type == StepType.podcast || halte.type == StepType.video }
function create_if_block(ctx) {
	let haltepodcastandvideo;
	let current;

	haltepodcastandvideo = new HaltePodcastAndVideo({
			props: {
				halte: /*halte*/ ctx[0],
				nextHalte: /*nextHalte*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(haltepodcastandvideo.$$.fragment);
		},
		m(target, anchor) {
			mount_component(haltepodcastandvideo, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const haltepodcastandvideo_changes = {};
			if (dirty & /*halte*/ 1) haltepodcastandvideo_changes.halte = /*halte*/ ctx[0];
			if (dirty & /*nextHalte*/ 4) haltepodcastandvideo_changes.nextHalte = /*nextHalte*/ ctx[2];
			haltepodcastandvideo.$set(haltepodcastandvideo_changes);
		},
		i(local) {
			if (current) return;
			transition_in(haltepodcastandvideo.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(haltepodcastandvideo.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(haltepodcastandvideo, detaching);
		}
	};
}

function create_fragment(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*halte*/ ctx[0].type == StepType.podcast || /*halte*/ ctx[0].type == StepType.video) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let halte;
	let nextHalte;
	let { params } = $$props;
	let halteType = "";
	halteType = params.halteType;

	$$self.$$set = $$props => {
		if ('params' in $$props) $$invalidate(3, params = $$props.params);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*params*/ 8) {
			$: $$invalidate(0, halte = db.getStepForParentType(params.parentSlug, params.halteSlug, params.halteType));
		}

		if ($$self.$$.dirty & /*halte*/ 1) {
			$: $$invalidate(2, nextHalte = db.getNextStep(halte));
		}
	};

	return [halte, halteType, nextHalte, params];
}

class HaltePage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { params: 3 });
	}
}

export default HaltePage;